import $ from 'jquery';

if( $( '.js--contribution-radio' ) ) {
  // let contrib = document.querySelector( '.js--contribution-radio' );
  //
  //   Array.from( contrib.children ).forEach( (child, index) => {
  //     child.addEventListener( "click", function() {
  //         $( '.contribution-form__radio--active' ).removeClass('contribution-form__radio--active');
  //         $( this ).addClass('contribution-form__radio--active');
  //     }) } );
  $( '.js--contribution-radio' ).children().click( function() {
    $( '.contribution-form__radio--active' ).removeClass('contribution-form__radio--active');
    $( this ).addClass('contribution-form__radio--active');
  })
}
var	buttonAmount    = $('.js--amount'),
	customAmount 	= $('.js--amount'),
	buttonDonate    = $('.js--button-donate'),
  frequencyButton = $('.js--frequency'),
  urlValue

// Toggling amount
buttonAmount.on('change', function() {
	$('.js--amount').val();
  console.log( $('.js--amount').val() )
});



// Resetting amounts and setting the custom-amount
customAmount.on('change', function() {
	$('.js--amount').removeClass('active');
});

buttonDonate.on( 'click', function(e) {
	e.preventDefault();
	var amountInput 	= customAmount.val(),
		amountButton 	= $('.js--amount').val(),
		frequency;

    if ( $('.contribution-form__radio--active').data('interval') == 'monthly' ) {
      frequency = '&interval=' + $('.contribution-form__radio--active').data('interval')
    } else if( $('.contribution-form__radio--active').data('interval') == 'annual' ) {
      frequency = '&interval=' + $('.contribution-form__radio--active').data('interval')
    } else {
      frequency = ''
    }

	urlValue = 'https://thehatchinstitute.giv.sh/2895?amount=' + amountButton + frequency
	if ( $.trim(amountInput).match(/^\d+$/) || $.trim(amountButton).match(/^\d+$/) )
		window.location.replace(urlValue);
});
